import { Component } from '@angular/core';

@Component({
  selector: 'app-instagram-login',
  standalone: true,
  imports: [],
  templateUrl: './instagram-login.component.html',
  styleUrl: './instagram-login.component.scss'
})
export class InstagramLoginComponent {

}
